import { API } from "aws-amplify";
import { CONSTANTES } from "../utils/Constantes";

const PATH = "/";

export const callService = async (method, service, formData, endpointName = 'portal-gestion-proveedores') => {
  try {
    let headerUser = {};

    let data = {
      headers: headerUser,
      response: true,
    };

    let response = "";
    if ("POST" === method.toUpperCase()) {
      data.body = formData;
      response = await API.post(
        endpointName,
        service,
        data
      );
      response = response.data.payload;      
      console.log(
        "🚀 ~ file: callService.js ~ line 25 ~ callService ~ response",
        response
      );
    } else if ("GET" === method.toUpperCase()) {
      response = await API.get(
        endpointName,
        service
      );
    }
    return {
      ok: true,
      data: response,
      message: "",
    };
  } catch (error) {
    console.log(error);
    console.log("error.response:"+error.response);
    let message;
    if (!error || !error.response || !error.response.data)
      message = "Error interno en servicio";
    else if (!!error.response.data.error)
      message = error.response.data.error.message;
    else if (!!error.response.data && !!error.response.data.message) {
      message = error.response.data.message
    } else if (!!error.response.data.error && !!error.response.data.error.details) {
      message = error.response.data.error.details[0];
    }
    return {
      ok: false,
      data: null,
      message: message,
      networkError: (error.message == 'Network Error')
    };
  }
};
